<template>
  <div class="terms-page">
    <!-- Header with back navigation -->
    <header class="header">
      <div class="header-content">
        <v-btn
          icon="mdi-arrow-left"
          variant="text"
          color="white"
          @click="goBack"
          class="back-button"
        />
        <img 
          src="/assets/logo-text-only.png" 
          alt="Youngpro Logo" 
          class="logo-text"
          @click="goHome" 
        />
        <div class="spacer"></div>
      </div>
    </header>

    <!-- Main content -->
    <div class="content-container">
      <div class="content">
        <h1 class="page-title">Refund Policy 환불정책</h1>
        
        <div class="terms-content">
          <section class="terms-section">
            <h2>제1조 (목적)</h2>
            <p>
              본 환불정책은 Youngpro 멤버십 서비스 이용과 관련하여 발생할 수 있는 환불 기준 및 절차를 명확히 안내하여, 회원의 권익을 보호하고 불필요한 분쟁을 예방하기 위해 마련되었습니다.
            </p>
          </section>

          <section class="terms-section">
            <h2>제2조 (환불 가능 기간 및 기준)</h2>
            <ol>
              <li>Youngpro 멤버십은 월 단위 정기결제 서비스입니다.</li>
              <li>환불은 해당 월 결제일로부터 그 달의 말일(마감일) 이전에 요청한 경우에 한하여 전액 환불이 가능합니다.</li>
              <li>서비스 특성상 부분 환불 또는 일할 계산 환불은 제공되지 않습니다.</li>
              <li>결제 월이 지나면(다음 결제 주기가 시작되면) 환불은 불가합니다.</li>
              <li>예시
                <ul>
                  <li>1월 3일 결제: 1월 31일 이전 요청 시 전액 환불 가능</li>
                  <li>1월 3일 결제: 2월 1일 이후 환불 요청 시 처리 불가</li>
                </ul>
              </li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제3조 (환불 불가 사유)</h2>
            <p>다음의 경우 환불이 제한됩니다.</p>
            <ol>
              <li>환불 가능 기간(결제 월 말일)이 지난 경우</li>
              <li>회원의 귀책 사유로 계정이 제한 또는 이용 중단된 경우</li>
              <li>서비스 부정 이용이 확인된 경우</li>
              <li>제공된 자료의 무단 배포, 저작권 침해 행위 등이 확인된 경우</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제4조 (환불 절차)</h2>
            <ol>
              <li>환불 요청은 아래 이메일로 접수해야 합니다<br/>info@youngpro.club</li>
              <li>아래 정보를 함께 제공해야 정확한 처리가 가능합니다.
                <ul>
                  <li>회원명</li>
                  <li>가입 이메일 주소</li>
                  <li>결제일자</li>
                  <li>환불 요청 사유</li>
                </ul>
              </li>
              <li>회사는 환불 요청 접수 후, 요청 내용을 확인하여 영업일 기준 5~7일 이내 처리합니다.</li>
              <li>환불은 Toss Payments 정기결제 승인취소 방식으로 진행됩니다.</li>
              <li>카드사/은행의 내부 처리 일정에 따라 실제 환불 반영까지 추가 시간이 소요될 수 있습니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제5조 (자동결제 해지)</h2>
            <ol>
              <li>자동결제는 회원이 직접 이메일(info@youngpro.club) 로 요청할 경우 해지됩니다.</li>
              <li>해지 완료 시 다음 결제일부터 요금이 부과되지 않습니다.</li>
              <li>이미 결제된 해당 월 요금은 제2조 기준에 따라 처리됩니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제6조 (디지털 서비스 특성 안내)</h2>
            <ol>
              <li>Youngpro 멤버십은 온라인 콘텐츠 및 디지털 기반 서비스로 제공되며, 「전자상거래법」 및 소비자분쟁해결기준에 따라 교환 및 반품이 불가능한 유형의 상품입니다.</li>
              <li>다만, 결제 월 내 환불 요청 시에는 제2조 기준에 따라 전액 환불을 제공합니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제7조 (환불 시 유의사항)</h2>
            <ol>
              <li>환불이 완료되면 서비스 이용 권한은 즉시 종료됩니다.</li>
              <li>환불 후 제공된 자료 및 콘텐츠는 더 이상 이용이 불가하며, 다운로드된 자료는 삭제해야 합니다.</li>
              <li>환불 완료 후 학습 데이터 및 활동 기록은 복구되지 않습니다.</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제8조 (분쟁 해결)</h2>
            <p>본 정책에서 정하지 않은 사항은 관련 법령 및 소비자분쟁해결기준(공정거래위원회 고시) 에 따릅니다. 기타 분쟁 발생 시 회원과 회사는 상호 협의를 통해 해결하도록 노력합니다.</p>
          </section>
        </div>

        <div class="last-updated">
          <p>시행일자: 2025년 10월 1일</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <FooterDefault current-page="refund" />
  </div>
</template>

<script>
import FooterDefault from '@/components/FooterDefault.vue';

export default {
  name: 'RefundPolicy',
  components: {
    FooterDefault
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.terms-page {
  background-color: var(--bg);
  color: var(--text-primary);
  height: 100vh;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-scrollbar: none;
}

@media (max-width: 700px) {
  .terms-page {
    max-height: 92vh; /* fallback */
  max-height: calc(100dvh - 6vh); /* URL-bar-safe (see HomePage) */
  }
}

.header {
  height: 6vh;
  width: 100%;
  background-color: var(--bg);
  border-bottom: 1px solid var(--hairline);
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.back-button {
  flex-shrink: 0;
}

.logo-text {
  height: 24px;
  cursor: pointer;
  margin: 0 auto;
}

.spacer {
  width: 40px;
  flex-shrink: 0;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: calc(100vh - 6vh);
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  color: var(--text-primary);
}

.terms-content {
  margin-bottom: 40px;
}

.terms-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--hairline);
}

.terms-section:last-child {
  border-bottom: none;
}

.terms-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--accent-strong);
}

.terms-section p {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 12px;
}

.terms-section ol {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section li {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.terms-section ul {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section ul li {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.last-updated {
  text-align: center;
}

.last-updated p {
  font-size: 14px;
  color: var(--text-tertiary);
}
</style>
